export default class ISpeedReport {  
  constructor() {
    this._sMarks = new Map()
    this._eMarks = new Map()
  }

  timeStart(tag) {
    this._sMarks.set(tag, Date.now())
    return this
  }
  timeEnd(tag) {
    if (!this._sMarks.has(tag)) {
      return this
    }
    this._eMarks.set(tag, Date.now() - this._sMarks.get(tag))
    this._sMarks.delete(tag)    

    return this
  }
  time(tag, cost) {
    this._eMarks.set(tag, cost)
  }
  clear() {
    this._sMarks.clear()
    this._eMarks.clear()
  }
}